import React from 'react';
import { FieldRow } from 'components/FormElements';
import { styled, Grid } from '@mui/material';

export const Value = styled(Grid)<{ disabled?: boolean }>(
  ({ theme, disabled }) => ({
    color: disabled
      ? theme.palette.text.disabled
      : theme.palette.text.secondary,
    fontWeight: 'bold',
  }),
);

type CompanyInfoDisplayProps = {
  investee?: {
    legalName?: string | null;
    tradingName?: string | null;
    shareClass?: string | null;
    nominalShareValue?: string | number | null;
  };
};

const CompanyInfoDisplay: React.FC<CompanyInfoDisplayProps> = ({
  investee,
}) => (
  <>
    <FieldRow title="Legal name" centerTitle>
      <Value>{investee?.legalName || '-'}</Value>
    </FieldRow>
    <FieldRow title="Trading name" centerTitle>
      <Value>{investee?.tradingName || '-'}</Value>
    </FieldRow>
    <FieldRow title="Share class" centerTitle>
      <Value>{investee?.shareClass || '-'}</Value>
    </FieldRow>
    <FieldRow title="Nominal share value" centerTitle>
      <Value>{investee?.nominalShareValue || '-'}</Value>
    </FieldRow>
  </>
);

export default CompanyInfoDisplay;
